<script module lang="ts">
</script>

<script lang="ts">
    import { Rem } from "component-lib";
    import type { Snippet } from "svelte";
    import { fade } from "svelte/transition";
    import Container from "../Container.svelte";

    type MenuAnimation = "none" | "slideup";

    interface Props {
        centered?: boolean;
        fit?: boolean;
        children?: Snippet;
        shadow?: boolean;
        cls?: string;
        animation?: MenuAnimation;
        customContent?: boolean;
    }
    let {
        centered = false,
        fit = false,
        children,
        shadow = true,
        cls = "",
        animation = "slideup",
        customContent = false,
    }: Props = $props();
</script>

<!-- svelte-ignore a11y_no_static_element_interactions -->
<div
    oncontextmenu={(e) => e.preventDefault()}
    in:fade={{ duration: 100 }}
    class={`menu-content ${cls} animation-${animation}`}
    class:fit
    class:shadow={shadow && !customContent}
    class:centered>
    {#if customContent}
        {@render children?.()}
    {:else}
        <Container
            padding={["lg", "zero"]}
            background={"var(--surface-1)"}
            minWidth={Rem.fromPixels(200).toString()}
            borderRadius={"xl"}
            shadow={"var(--shadow-menu)"}
            width={"fill"}
            height={"fill"}
            direction={"vertical"}>
            {@render children?.()}
        </Container>
    {/if}
</div>

<style lang="scss">
    .menu-content {
        max-height: 80vh;
        max-height: var(--override-height, 80vh);
        border-radius: var(--rad-xl);

        &.animation-slideup {
            animation: slide-up 200ms ease-out forwards;
        }

        &.centered {
            width: 70vw;
        }

        &.shadow {
            box-shadow: var(--menu-sh);
        }

        &.fit {
            width: fit-content;
        }
    }
</style>
